export default "__VITE_ASSET__CzMhHVHy__"